module.exports = __webpack_public_path__ + "img/icon-filter.3da4cb8a.svg";